import api from '../lib/axios';
export async function getCommunes(params) {
    const { data } = await api.get('/api/superadmin/communes', { params });
    return data;
}
export async function getCommune(id) {
    const { data } = await api.get(`/api/superadmin/communes/${id}`);
    return data.data;
}
export async function createCommune(body) {
    const { data } = await api.post('/api/superadmin/communes', body);
    return data.data;
}
export async function updateCommune(id, body) {
    const { data } = await api.patch(`/api/superadmin/communes/${id}`, body);
    return data.data;
}
export async function toggleCommune(id) {
    const { data } = await api.patch(`/api/superadmin/communes/${id}/toggle`);
    return data.data;
}
export async function deleteCommune(id) {
    await api.delete(`/api/superadmin/communes/${id}`);
}
export async function testConnector(id, module) {
    const { data } = await api.post(`/api/superadmin/communes/${id}/test-connector/${module}`);
    return data;
}
export async function syncModule(id, module) {
    const { data } = await api.post(`/api/superadmin/communes/${id}/sync/${module}`);
    return data;
}
